import { useMutation } from '@tanstack/react-query'
import { useAPI } from '../../../Contexts/APIContext'
import errorToast from '../../../Components/Toasts/ErrorToast'
import successToast from '../../../Components/Toasts/SuccessToast'

const useDeleteOrganizationGroup = () => {
  const { deleteOrganizationGroup } = useAPI()

  return useMutation({
    mutationFn: data => deleteOrganizationGroup(data),
    onSuccess: () => {
      successToast('Team was deleted successfully')
    },
    onError: () => {
      errorToast('Something went wrong! Please try again later.')
    },
  })
}

export default useDeleteOrganizationGroup
